export default "__VITE_ASSET__Cxl1QusS__"